import { useEffect, useMemo } from "react";
import {
  CircleMarker,
  MapContainer,
  Polygon,
  Polyline,
  TileLayer,
  Tooltip,
  useMap,
} from "react-leaflet";

const DEFAULT_CENTER = [-6.369028, 34.888822];

function FitGeometry({ positions }) {
  const map = useMap();

  useEffect(() => {
    const timeout = window.setTimeout(() => {
      map.invalidateSize();

      if (positions.length === 1) {
        map.setView(positions[0], 18);
      } else if (positions.length > 1) {
        map.fitBounds(positions, { padding: [30, 30], maxZoom: 18 });
      }
    }, 350);

    return () => window.clearTimeout(timeout);
  }, [map, positions]);

  return null;
}

export default function InquiryGeometryMap({ points = [] }) {
  const positions = useMemo(() => (
    points
      .map((point) => [Number(point.lat), Number(point.lng)])
      .filter(([lat, lng]) => Number.isFinite(lat) && Number.isFinite(lng))
  ), [points]);

  if (positions.length === 0) {
    return null;
  }

  return (
    <div style={{ height: "340px", width: "100%", borderRadius: "8px", overflow: "hidden" }}>
      <MapContainer
        center={positions[0] || DEFAULT_CENTER}
        zoom={18}
        scrollWheelZoom
        style={{ height: "100%", width: "100%" }}
      >
        <FitGeometry positions={positions} />
        <TileLayer
          attribution="© OpenStreetMap"
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />

        {positions.length === 2 ? <Polyline positions={positions} /> : null}
        {positions.length >= 3 ? <Polygon positions={positions} /> : null}

        {positions.map((position, index) => (
          <CircleMarker
            center={position}
            key={`${position[0]}-${position[1]}-${index}`}
            radius={7}
            pathOptions={{ color: "#ffffff", fillColor: "#212529", fillOpacity: 1, weight: 2 }}
          >
            <Tooltip permanent direction="top" offset={[0, -8]}>
              {index + 1}
            </Tooltip>
          </CircleMarker>
        ))}
      </MapContainer>
    </div>
  );
}
